import api from '../index';

const giftCodeUpdaters = {
  sendCoupon: async ({
    giftCodeId,
    couponCode,
  }: {
    giftCodeId: string;
    couponCode: string;
  }) => {
    const body = {data: {coupon_code: couponCode}};
    return api.put(`/gift_codes/${giftCodeId}/send_coupon`, body, {
      customSerializer: () => body,
    });
  },
};

export default giftCodeUpdaters;
